import Banner from 'app/components/partials/banner';
import ContactUsForm from 'app/components/partials/contact-us-form.container';
import ContentBlocks from 'app/components/content-blocks/index';
import PropTypes from 'prop-types';
import React from 'react';

function ContactUs(props) {
    const {
        blocks,
        name: title,
        parent: parentSlug
    } = props.data;

    return (
        <div className="content-page">
            <Banner
                title={title}
                parentSlug={parentSlug}
            />
            <ContentBlocks data={blocks} />
            <ContactUsForm />
        </div>
    );
}

ContactUs.propTypes = {
    data: PropTypes.object.isRequired
};

export default ContactUs;
